<template>
  <ion-page>
    <master-layout pageTitle="اطلاعات شخصی">
      <ion-card>
        <ion-card-content>
          <AjaxForm route="editUserinfo">
                <div class="mb-2">
                  <label>نام کامل</label>
                  <input type="text"  name="fullname" class="form-control" :value="user.fullname">
                </div>

                <div class="mb-2">
                  <label>نام کاربری</label>
                  <input type="text"  name="username" class="form-control" :value="user.username">
                </div>

                <div class="mb-2">
                  <label>تلفن همراه</label>
                  <input type="tel" name="phone" class="form-control" :value="user.phone">
                </div>

                <div class="mb-2">
                  <label>کد ملی</label>
                  <input type="text" name="national_code" class="form-control" :value="user.national_code">
                </div>

                <div class="mb-2">
                  <label>ایمیل</label>
                  <input name="email" type="email" class="form-control" :value="user.email">
                </div>

                <button class="btn btn-block btn-lg btn-success mt-2" type="submit">
                  ویرایش اطلاعات <i class="far fa-edit"></i>
                </button>

              </AjaxForm>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
// import {showSystemNoti} from '@/shared/helper'
import {IonPage,IonCard,IonCardContent} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    AjaxForm,
    IonPage,IonCard,IonCardContent
  },
  data()
  {
    return {
      id:null,
      userLoaded: false,
      error:null,
    }
  },
  async created()
  {

  },
  methods: {
    ...mapActions("admin", {
      getUserInfo: 'getUserInfo',
    }),
  },
  computed: {
    ...mapGetters("auth", {
      user: "getUserInfo",
    }),
  },
}

</script>

<style scoped>

</style>